// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {
	const options = {
		controls: true,
		autoplay: false,
		preload: "auto",
	};

	const players = {}

	$(".sec-main-news .video-js-wrap").each(function () {
		players[$(this).data("tab")] = window.videojs($(this).find(".video-js")[0], options);
	});


	$(".sec-main-news__videos-top").on("click", ".sec-main-news__videos-tab:not(.sec-main-news__videos-tab_active)", function() {
		const tabId = $(this).data("tab")
		if (!tabId) return

		$(this)
			.addClass("sec-main-news__videos-tab_active")
			.siblings()
			.removeClass("sec-main-news__videos-tab_active")
			.closest(".sec-main-news__videos")
			.find(".video-js-wrap")
			.removeClass("video-js-wrap_active")

		$(`.video-js-wrap[data-tab="${tabId}"]`)
			.addClass("video-js-wrap_active");

		for (const key in players) {
			players[key].pause();
			players[key].currentTime(0);
			players[key].trigger("loadstart");
		}
	});

	const stickyOffset = $(".sec-main-news__sidebar-tape").offset().top - $(".header__top").outerHeight();
	let videoClosed = false

	$(".sec-main-news__videos-close").on("click", function () {
		$(".sec-main-news").removeClass("sec-main-news_scroll");
		videoClosed = true;
		for (const key in players) {
			players[key].pause();
			players[key].currentTime(0);
			players[key].trigger("loadstart");
		}
	})
	$(".sec-main-news__tab-item").on("click", function () {
		$('.sec-main-news__tabs-cell').removeClass('sec-main-news__tabs-cell--active');
		$(this).closest('div').addClass('sec-main-news__tabs-cell--active');
		$(".sec-main-news__tab-data").hide().eq($(this.closest('div')).index()).fadeIn()
	})

	function checkScroll () {
		const scrollTop = $(window).scrollTop();
		if (scrollTop > stickyOffset) {
			$(".sec-main-news").addClass("sec-main-news_scroll");
		}
		else {
			$(".sec-main-news").removeClass("sec-main-news_scroll");
		}
	}

	checkScroll();

	if (window.innerWidth > 1230) {
		$(window).scroll(function () {
			if (videoClosed) return;
			checkScroll();
		});
	}
});
